import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.VUE_APP_BACKEND_URL, 
    headers: {
        'Content-Type': 'application/json',
        // 'Authorization': "Bearer " + localStorage.getItem("api_token")
    }
});